import { render } from "./singlefuelreport.vue?vue&type=template&id=ef92075c"
import script from "./singlefuelreport.vue?vue&type=script&lang=js"
export * from "./singlefuelreport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__